import { useQuery } from "react-query"
import { get_job_seeker_certifications } from "../../../services/approvals";


const useJobSeekerCertifications = (id) => {
    return useQuery('get_job_seeker_certification', ()=> get_job_seeker_certifications(id))
}

export default useJobSeekerCertifications;